"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genListTime = void 0;
const moment_1 = __importDefault(require("moment"));
const genListTime = (start, end) => {
    const timeFormat = 'HH:mm';
    const startTime = (0, moment_1.default)(start, timeFormat, true);
    const deadTime = (0, moment_1.default)(end, timeFormat, true);
    const dur = moment_1.default.duration(deadTime.diff(startTime));
    let result = dur.asHours();
    if (result < 0)
        result += 24;
    result += 1;
    const list = [];
    Array.from({ length: result }).forEach(_ => {
        list.push({
            label: startTime.format(timeFormat).toString(),
            value: startTime.format(timeFormat).toString(),
        });
        startTime.add(1, 'hour');
    });
    return list;
};
exports.genListTime = genListTime;
